import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

// const baseHost = '//127.0.0.1'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /**
   * 教研中心-虚拟教研室-团队建设-详情
   */
  getTeamBuildingDetail(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-teambuild_info/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-成员列表
   */
   getTeamBuildingDetailList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-teambuild_member_list/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-成员编辑
   */
  editMemberInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-teambuild_member_upd/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-成员删除
   */
  delMemberInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/91-teambuild_member_del/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-成员添加
   */
  addMemberInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-teambuild_member_add/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-获取个人信息
   */
  getTeamPersonalInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-teambuild_person_info/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-个人信息保存
   */
  saveTeamPersonalInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-teambuild_person_save/page_jiaoyanshi`, params, config)
  },
   /**
   * 教研中心-虚拟教研室-团队建设-添加成员列表
   */
   addTeammemberList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-teambuild_member_chose_list/page_jiaoyanshi`, params, config)
  },
   /**
   * 教研中心-虚拟教研室-团队建设-职务列表
   */
   getRoleList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teambuild_role_list/page_jiaoyanshi`, params, config)
  },
   /**
   * 教研中心-虚拟教研室-团队建设-权限列表
   */
   getTeamBuildAuthList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teambuild_auth_list/page_jiaoyanshi`, params, config)
  },
   /**
   * 教研中心-虚拟教研室-团队建设-成员单位
   */
   getRoleOrgan(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-teambuild_role_organ_get/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-成员单位信息保存
   */
  saveOrganInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-teambuild_role_organ_upd/page_jiaoyanshi`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-团队建设-权限查询
   */
  getAuthInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-teambuild_auth/page_jiaoyanshi`, params, config)
  },
}
